import Svg from "@/components/Svg";

const CirclePath = ({ color }) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M40 76.7568C60.3002 76.7568 76.7568 60.3002 76.7568 40C76.7568 19.6998 60.3002 3.24324 40 3.24324C19.6998 3.24324 3.24324 19.6998 3.24324 40C3.24324 60.3002 19.6998 76.7568 40 76.7568ZM40 80C62.0914 80 80 62.0914 80 40C80 17.9086 62.0914 0 40 0C17.9086 0 0 17.9086 0 40C0 62.0914 17.9086 80 40 80Z"
    fill={color}
  />
);

export default function EndocrineIcon({ size = 40, withCircle = true, color }) {
  const viewBox = withCircle ? "0 0 80 80" : "0 0 40 40";
  const iconTransform = withCircle ? "translate(20 20)" : "";

  return (
    <Svg
      as="svg"
      width={size}
      height={size}
      minWidth={size}
      minHeight={size}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withCircle && <CirclePath color={color} />}
      <g transform={iconTransform}>
        <path
          d="M34.2884 24.3384V15.6649C35.4446 15.2575 36.3571 14.3404 36.7671 13.1692C37.1772 11.9998 37.041 10.7043 36.3957 9.64734C35.7521 8.59212 34.6699 7.88982 33.4549 7.73808C32.2399 7.58807 31.0232 8.00572 30.1476 8.87343L23.4794 5.49131C23.5114 5.32937 23.5282 5.16572 23.5332 5.00036C23.5332 2.74163 21.7267 0.909088 19.5 0.909088C17.2733 0.909088 15.4668 2.74163 15.4668 5.00036C15.4718 5.16572 15.4886 5.32937 15.5206 5.49131L8.85235 8.87343C7.97679 8.00573 6.76012 7.58809 5.54513 7.73808C4.33013 7.8898 3.2479 8.59212 2.60427 9.64734C1.95896 10.7043 1.82284 11.9998 2.23288 13.1692C2.64292 14.3404 3.55542 15.2575 4.71161 15.6649V24.3384C2.87651 25.0135 1.78249 26.9262 2.11186 28.8761C2.44292 30.828 4.10325 32.26 6.05601 32.2753C6.83576 32.2753 7.59701 32.0435 8.2474 31.6071L15.5609 35.8484C15.9559 37.7509 17.6178 39.1078 19.5336 39.0907C21.4511 39.0754 23.0896 37.6895 23.4526 35.7802L30.2417 31.198C30.9744 31.8918 31.9407 32.2771 32.9439 32.2754C34.8967 32.2601 36.557 30.8281 36.8881 28.8762C37.2174 26.926 36.1235 25.0133 34.2884 24.3384ZM31.5996 24.3384C29.9947 24.918 28.9192 26.4557 28.9108 28.1842C28.9158 28.3854 28.9326 28.5865 28.9646 28.7843L22.9283 32.8619C22.1889 31.6311 20.863 30.8896 19.4429 30.9117C18.0212 30.9339 16.7189 31.7181 16.0181 32.971L9.88764 29.4117C10.017 29.0162 10.0859 28.6019 10.0893 28.1843C10.0809 26.4557 9.00539 24.9181 7.4005 24.3385V15.665C9.00539 15.0854 10.0809 13.5477 10.0893 11.8192C10.0843 11.6538 10.0675 11.4902 10.0355 11.3282L16.7037 7.94612C18.2649 9.47012 20.7353 9.47012 22.2964 7.94612L28.9647 11.3282C28.9327 11.4902 28.9159 11.6538 28.9109 11.8192C28.9193 13.5477 29.9948 15.0854 31.5997 15.665L31.5996 24.3384Z"
          fill={color}
        />
      </g>
    </Svg>
  );
}
